module.exports = __webpack_public_path__ + "media/fonts/calibri/Calibri-Light-Italic-02dbe5c8b2af773ba84218492936326b.ttf";